import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { militaryBahCalculator_template } from "../components/templates/militaryBahCalculator_template";

export class military_bah_calculator extends vnModule_knockoutJS {
    protected militaryBahCalculatorForm: militaryBahCalculator_template;

    buildContent(): Array<Element> {
        this.militaryBahCalculatorForm = new militaryBahCalculator_template('militaryBahCalculatorTemplate', this.viewModel, this);
        return [this.militaryBahCalculatorForm.build()];
    }

    protected getModuleName(): string { return "military_bah_calculator"; }

    public fillPage() {
        this.setSaveStatus('');
    }

    protected filterSimpleOnChange(idElement) {}

    public async save(payload: object): Promise<void> {
        const idBrand = this.getVnAppZone().getApp().params.idBrand;
        if (idBrand == null || idBrand === undefined) {
            this.setSaveStatus('Error: brand not found');
            return Promise.resolve();
        }
        this.setSaveStatus('Saving...');
        return fetch('/api/brand/' + idBrand + '/config/military-bah-calculator/save/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ data: JSON.stringify(payload) }),
            credentials: 'same-origin'
        }).then((res) => {
            if (!res.ok) return res.json().then((err: { error?: string }) => { throw new Error(err.error || res.statusText); });
            return res.json();
        }).then(() => this.setSaveStatus('Saved!')).catch((err: Error) => this.setSaveStatus('Error: ' + (err.message || 'Save failed')));
    }

    private setSaveStatus(status: string): void {
        const vm = this.viewModel['militaryBahCalculatorTemplate'];
        if (vm && typeof vm.saveStatus === 'function') vm.saveStatus(status);
    }
}



// WEBPACK FOOTER //
// ./js/modules/military_bah_calculator.ts